import type { ReactNode } from 'react';
import { Link } from 'react-router';

interface Props {
  title: ReactNode;
  /** Dokąd prowadzi przycisk Wstecz (brak = bez przycisku). */
  back?: string;
  right?: ReactNode;
}

export function PageHeader({ title, back, right }: Props) {
  return (
    <header className="safe-top sticky top-0 z-10 border-b border-stone-200 bg-stone-50/95 backdrop-blur dark:border-stone-800 dark:bg-stone-950/95">
      <div className="flex min-h-14 items-center gap-2 px-4">
        {back && (
          <Link
            to={back}
            aria-label="Wstecz"
            className="-ml-2 flex size-11 shrink-0 items-center justify-center rounded-full text-3xl leading-none text-stone-600 active:bg-stone-200 dark:text-stone-300 dark:active:bg-stone-800"
          >
            ‹
          </Link>
        )}
        <h1 className="min-w-0 flex-1 truncate text-xl font-bold">{title}</h1>
        {right}
      </div>
    </header>
  );
}
